import { render } from "./canais-whatsapp.vue?vue&type=template&id=50755fc3&scoped=true"
import script from "./canais-whatsapp.vue?vue&type=script&lang=js"
export * from "./canais-whatsapp.vue?vue&type=script&lang=js"

import "./canais-whatsapp.vue?vue&type=style&index=0&id=50755fc3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50755fc3"]])

export default __exports__